import anime from '@/assets/libs/anime';
import { inApp } from '@/scripts/utils';
import { gridHideInit, gridHideAnim } from './gridHide';

export function listInit(el) {
  const ctx = el;

  if (inApp()) {
    anime.set(ctx, { opacity: 0, translateY: 25 });
  } else {
    const contetButtons = [...ctx.querySelectorAll('.button span')];
    const svgs = [...ctx.querySelectorAll('.button svg')];
    const gridHides = [...el.querySelectorAll('.grid-hide')];

    anime.set(contetButtons, { opacity: 0, translateY: '100%' });
    anime.set(svgs, { scale: 0 });
    gridHideInit(gridHides);
  }
}

export function listAnim(el, delay = 0) {
  const ctx = el;
  let tl;

  if (inApp()) {
    tl = anime({
      targets: ctx,
      translateY: 0,
      easing: 'cubicBezier(.5,0,0,1)',
      duration: 1000,
      opacity: {
        value: 1,
        duration: 700,
        delay: delay + 100,
      },
      delay,
    });
  } else {
    const contetButtons = [...ctx.querySelectorAll('.button span')];
    const svgs = [...ctx.querySelectorAll('.button svg')];
    const gridHides = [...el.querySelectorAll('.grid-hide')];
    tl = anime.timeline({
      easing: 'cubicBezier(.5,0,0,1)',
      duration: 1800,
    });

    gridHides.forEach((gridHide) => gridHideAnim(gridHide, delay));
    tl
      .add({
        targets: contetButtons,
        opacity: 1,
        translateY: 0,
        delay: anime.stagger(300, { start: delay + 300 }),
      }, 0)
      .add({
        targets: svgs,
        scale: 1,
        delay: anime.stagger(350, { start: delay + 300 }),
      }, 0);
  }

  return tl;
}

export function listOut(el, delay = 0) {
  const ctx = el;
  let tl;
  ctx.style.pointerEvents = 'none';

  if (inApp()) {
    tl = anime({
      targets: ctx,
      translateY: -25,
      easing: 'cubicBezier(.5,0,0,1)',
      duration: 1000,
      opacity: {
        value: 0,
        duration: 500,
      },
      delay,
    });
  } else {
    const contetButtons = [...ctx.querySelectorAll('.button span')];
    const svgs = [...ctx.querySelectorAll('.button svg')];
    const gridHides = [...ctx.querySelectorAll('.grid-hide')];
    tl = anime.timeline({
      easing: 'cubicBezier(.5,0,0,1)',
      duration: 1200,
      complete: () => {
        ctx.style.pointerEvents = 'auto';
      },
    });

    tl
      .add({
        targets: contetButtons,
        opacity: {
          value: 0,
          duration: 500,
        },
        translateY: '-100%',
        delay: anime.stagger(300, { start: delay }),
      }, 0)
      .add({
        targets: svgs,
        scale: 0,
        delay: anime.stagger(350, { start: delay }),
      }, 0)
      .add({
        targets: gridHides,
        scaleY: 0,
        opacity: 0,
        duration: 800,
        delay: anime.stagger(150, { start: delay }),
      }, 500);
  }

  return tl;
}
